import "../../assets/styles/NotFound/notFound.css";
import notFound from "../../assets/images/404.svg";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <img src={notFound} alt="" />
        <h3>صفحه مورد نظر پیدا نشد</h3>
        <p>آدرس صفحه ای که جستجو کردید تغییر کرده است یا وجود ندارد</p>
      </div>
    </div>
  );
};

export default NotFound;
